import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../components/ui/dialog';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Crown, Check, Loader2 } from 'lucide-react';

export const UpgradeDialog = ({ open, onOpenChange, isDemoProspect, onUpgrade }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md" data-testid="upgrade-dialog">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Crown className="w-5 h-5 text-[#B4A048]" />
          {isDemoProspect ? 'Convert Your Demo' : 'Upgrade to Pro'}
        </DialogTitle>
        <DialogDescription>
          {isDemoProspect ? 'Convert your demo to a full account first, then subscribe to connect your bank.' : 'Bank connections require a paid plan.'}
        </DialogDescription>
      </DialogHeader>
      <div className="py-4 space-y-4">
        <div className="bg-[#F6F5F2] border border-[#E6E8E6] rounded-sm p-4">
          <h4 className="font-medium text-[#111614] mb-2">Why upgrade?</h4>
          <ul className="space-y-2 text-sm text-[#5C6661]">
            {['Auto-import transactions from your bank', 'Unlimited businesses', 'Receipt scanning & mileage tracking', 'Smart auto-categorization'].map(item => (
              <li key={item} className="flex items-center gap-2"><Check className="w-4 h-4 text-[#0A2B1D]" />{item}</li>
            ))}
          </ul>
        </div>
        {!isDemoProspect && (
          <div className="text-center">
            <p className="text-2xl font-semibold text-[#111614]">$19<span className="text-sm font-normal text-[#5C6661]">/mo</span></p>
            <p className="text-xs text-[#8A948F]">Cancel anytime. Up to 80% cheaper than QuickBooks.</p>
          </div>
        )}
      </div>
      <DialogFooter className="flex gap-2">
        <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-sm">Maybe Later</Button>
        <Button onClick={onUpgrade} className="bg-[#0A2B1D] hover:bg-[#254D3D] rounded-sm" data-testid="upgrade-to-pro-btn">
          <Crown className="w-4 h-4 mr-1" />
          {isDemoProspect ? 'Convert Account' : 'Upgrade Now - $19/mo'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);

export const ConvertDemoDialog = ({ open, onOpenChange, name, setName, password, setPassword, loading, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-md bg-white border-[#E6E8E6]" data-testid="convert-demo-dialog">
      <DialogHeader>
        <DialogTitle className="text-[#111614]">Upgrade to Full Account</DialogTitle>
        <DialogDescription className="text-[#5C6661]">
          Set your name and password to convert your demo into a permanent account. All your data will be preserved.
        </DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4 pt-4">
        <div>
          <Label className="text-[#111614]">Full Name</Label>
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="John Smith" required className="bg-[#FAFAF8] border-[#E6E8E6]" data-testid="convert-name-input" />
        </div>
        <div>
          <Label className="text-[#111614]">Set Your Password</Label>
          <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 6 characters" required minLength={6} className="bg-[#FAFAF8] border-[#E6E8E6]" data-testid="convert-password-input" />
        </div>
        <div className="bg-[#E2ECE7] rounded-lg p-3 text-sm text-[#0A2B1D]">
          <p className="font-medium mb-1">What happens next:</p>
          <ul className="space-y-1 text-xs text-[#5C6661]">
            {['All your businesses and data are kept', '14-day free trial starts automatically', 'Unlock bank connections & payments'].map(item => (
              <li key={item} className="flex items-center gap-2"><Check className="w-3 h-3 text-[#3A6E53]" />{item}</li>
            ))}
          </ul>
        </div>
        <Button type="submit" className="w-full bg-[#0A2B1D] hover:bg-[#254D3D] text-white rounded-sm" disabled={loading} data-testid="convert-submit-btn">
          {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Crown className="w-4 h-4 mr-2" />}
          {loading ? 'Upgrading...' : 'Upgrade Account'}
        </Button>
      </form>
    </DialogContent>
  </Dialog>
);
